import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Header, Footer } from "@/components/SiteChrome";
import api from "@/lib/api";

export default function Blog() {
    const [posts, setPosts] = useState([]);
    useEffect(() => { api.get("/blog").then(({ data }) => setPosts(data.items)); }, []);
    return (
        <div className="min-h-screen bg-[hsl(var(--dust-50))]" data-testid="blog-page">
            <Header />
            <div className="border-b-2 border-[hsl(var(--ink))] bg-[hsl(var(--dust-300))] text-[hsl(var(--dust-50))]">
                <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
                    <div className="font-mono-brand text-xs uppercase tracking-[0.25em] text-[hsl(var(--dust-100))]">Journal</div>
                    <h1 className="mt-2 font-display text-5xl uppercase italic md:text-7xl">Field notes.</h1>
                </div>
            </div>
            <div className="mx-auto grid max-w-7xl gap-8 px-4 py-12 sm:px-6 md:grid-cols-2 lg:grid-cols-3">
                {posts.map((p) => (
                    <Link key={p.slug} to={`/blog/${p.slug}`} className="group flex flex-col border border-[hsl(var(--dust-300))] bg-card transition-transform hover:-translate-y-1" data-testid={`blog-tile-${p.slug}`}>
                        <div className="aspect-[16/10] overflow-hidden bg-[hsl(var(--dust-300))]">
                            {p.cover_image && <img src={p.cover_image} alt={p.title} className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" />}
                        </div>
                        <div className="flex flex-1 flex-col gap-2 p-6">
                            <div className="font-mono-brand text-[10px] uppercase tracking-wider text-[hsl(var(--ink-soft))]">
                                {new Date(p.created_at).toLocaleDateString()}
                            </div>
                            <h2 className="font-heading text-xl uppercase leading-tight text-[hsl(var(--ink))]">{p.title}</h2>
                            <p className="text-sm text-[hsl(var(--ink-soft))]">{p.excerpt}</p>
                            <span className="mt-auto font-mono-brand text-xs uppercase text-[hsl(var(--ink))] group-hover:underline">Read →</span>
                        </div>
                    </Link>
                ))}
            </div>
            <Footer />
        </div>
    );
}
